var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_c('img',{attrs:{"src":require("@/assets/image/favicon.png"),"alt":""}}),_c('span',{staticClass:"title"},[_vm._v("金鳌海洋")])])}
var staticRenderFns = []

export { render, staticRenderFns }